import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyPreferencePrompt"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/CurrencyPicker/CurrencyPreferencePrompt.tsx");
